import * as React from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { getCloudMetadata, getCurrentUser } from "./getCurrentUser";

const RETURN_PATH_KEY = "labelmaster.returnPath";

export function persistReturnPath(path: string) {
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, path);
  } catch {
    // ignore
  }
}

export function consumeReturnPath(): string | null {
  try {
    const value = sessionStorage.getItem(RETURN_PATH_KEY);
    if (value) {
      sessionStorage.removeItem(RETURN_PATH_KEY);
    }
    return value;
  } catch {
    // ignore
  }
  return null;
}

/** Redirects to Google OAuth (used by the Google button on the sign-in page). */
export function redirectToSignIn(returnPath?: string) {
  const metadata = getCloudMetadata();
  if (returnPath) {
    persistReturnPath(returnPath);
  }
  if (metadata?.SignInUrl) {
    window.location.href = metadata.SignInUrl;
  }
}

/** Navigate to the SPA sign-in page (Google + email/password). */
export function goToSignInPage(navigate: (to: string) => void, returnPath: string) {
  const path = returnPath.startsWith("/") ? returnPath : "/" + returnPath;
  navigate(`/signin?return=${encodeURIComponent(path)}`);
}

type GuardProps = {
  children: React.ReactNode;
};

export function RequireAuth({ children }: GuardProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      goToSignInPage(navigate, location.pathname + location.search);
    }
  }, [user, location.pathname, location.search, navigate]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  return <>{children}</>;
}

export function RequireAdmin({ children }: GuardProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      goToSignInPage(navigate, location.pathname + location.search);
    }
  }, [user, location.pathname, location.search, navigate]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  if (!user.IsAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
